var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.804,
    height: 21.7,
    viewBox: "0 0 18.804 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    "data-name": "Layer 2",
    d: "M21.08,3.891H15.946a3.616,3.616,0,0,0-7.087,0H3.723a.723.723,0,0,0,0,1.446h.723V17.7a5,5,0,0,0,5,5H15.36a5,5,0,0,0,5-5V5.338h.723a.723.723,0,0,0,0-1.446ZM12.4,2.445a2.174,2.174,0,0,1,2.046,1.446H10.356A2.174,2.174,0,0,1,12.4,2.445ZM10.955,16.909a.723.723,0,1,1-1.446,0V9.677a.723.723,0,0,1,1.446,0Zm4.339,0a.723.723,0,1,1-1.446,0V9.677a.723.723,0,0,1,1.446,0Z",
    transform: "translate(-3 -0.995)",
    fill: "#ff1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.98cd79a85b46f794022736e9d9cc9b6d.svg";
export { ForwardRef as ReactComponent };